<template>
  
    <div>
        <div class="tags ">
            <button class="button tag is-small" :class="{'is-success' : order.requires_silicon_stripes==1}" :disabled="working==true" @click="toggleSilicon()">Silicon</button>
            <button class="button tag is-small" :class="{'is-success' : order.requires_dtf==1}" :disabled="working==true" @click="toggleDTF()">DTF</button>
        </div>
      </div>
  
  </template>
  
  <script>
  
  export default {
    data() {
      return {
       
      }
    },
    props: ['order', 'working'],
    
    methods: {
        toggleSilicon() {
          
        this.$emit('toggleSilicon')
      },
      toggleDTF() {
          
          this.$emit('toggleDTF')
        },
      
      
          
    },
    created() {
     
    },
    mounted() {
      
      
    },
    watch: {
     
    }
    
  
  }
  </script>
  
  <style scoped>
    span.tag {text-decoration:none} 
  </style>
  